import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { nav, whatsappLink } from '../site-config';

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-[#d9d4cc] bg-[var(--site-paper)]/95 backdrop-blur-sm">
      <div className="relative mx-auto flex h-[4.25rem] max-w-6xl items-center justify-between gap-4 px-4">
        <a href="/" className="flex shrink-0 items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2b9ce1]">
          <BrandLogo variant="compact" className="h-8" />
        </a>

        <nav aria-label="Navegação principal" className="hidden items-center gap-1 lg:flex">
          {nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="inline-flex min-h-10 items-center rounded-md px-3 text-sm text-[#5c5852] transition-colors duration-150 hover:text-[#16181d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2b9ce1]"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="/login"
            className="inline-flex min-h-10 items-center px-2 text-sm text-[#5c5852] transition-colors duration-150 hover:text-[#16181d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2b9ce1]"
          >
            Entrar
          </a>
          <Button asChild variant="default" size="sm">
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
              Falar no WhatsApp
            </a>
          </Button>
        </div>

        <details data-site-mobile-menu className="group relative lg:hidden">
          <summary className="flex min-h-10 cursor-pointer list-none items-center gap-2 rounded-md px-3 text-sm font-medium text-[#16181d] [&::-webkit-details-marker]:hidden">
            <Menu className="h-4 w-4" aria-hidden />
            Menu
          </summary>
          <nav
            aria-label="Navegação móvel"
            className="absolute right-0 top-[calc(100%+8px)] w-64 rounded-xl border border-[#d9d4cc] bg-white p-2 shadow-[0_12px_32px_rgba(14,26,40,0.12)]"
          >
            {nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="flex min-h-10 items-center rounded-md px-3 text-sm text-[#16181d]"
              >
                {item.label}
              </a>
            ))}
            <div className="my-2 border-t border-[#d9d4cc]" />
            <a href="/login" className="flex min-h-10 items-center rounded-md px-3 text-sm text-[#16181d]">
              Entrar
            </a>
            <Button asChild variant="default" size="sm" className="mt-2 w-full">
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
                Falar no WhatsApp
              </a>
            </Button>
          </nav>
        </details>
      </div>
    </header>
  );
}
